import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { sharedLearningResources } from '@quebon/shared-learning/i18n'

// Korean
import koCommon from './locales/ko/common.json'
import koAuth from './locales/ko/auth.json'
import koNav from './locales/ko/nav.json'
import koDashboard from './locales/ko/dashboard.json'
import koLearner from './locales/ko/learner.json'
import koAdmin from './locales/ko/admin.json'
import koConfiguration from './locales/ko/configuration.json'
import koContract from './locales/ko/contract.json'
import koMessages from './locales/ko/messages.json'

// English
import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enNav from './locales/en/nav.json'
import enDashboard from './locales/en/dashboard.json'
import enLearner from './locales/en/learner.json'
import enAdmin from './locales/en/admin.json'
import enConfiguration from './locales/en/configuration.json'
import enContract from './locales/en/contract.json'
import enMessages from './locales/en/messages.json'

export const SUPPORTED_LANGUAGES = ['ko', 'en'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: {
        common: koCommon,
        auth: koAuth,
        nav: koNav,
        dashboard: koDashboard,
        learner: koLearner,
        admin: koAdmin,
        configuration: koConfiguration,
        contract: koContract,
        messages: koMessages,
        ...sharedLearningResources.ko,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        nav: enNav,
        dashboard: enDashboard,
        learner: enLearner,
        admin: enAdmin,
        configuration: enConfiguration,
        contract: enContract,
        messages: enMessages,
        ...sharedLearningResources.en,
      },
    },
    defaultNS: 'common',
    fallbackLng: 'ko',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18n
